import { cn } from '@/lib/utils';

/**
 * Get the base container styles for a chat message
 * Handles flex layout and role-based alignment
 */
export const getBubbleContainerStyles = (role: 'user' | 'assistant') =>
  cn(
    'flex items-start gap-1 pt-1 pb-0 group w-full',
    role === 'user' ? 'flex-row-reverse' : 'flex-row',
  );

/**
 * Get the bubble content wrapper styles
 * Different alignment for user vs assistant
 */
export const getBubbleContentStyles = (role: 'user' | 'assistant') =>
  cn('flex flex-col', role === 'user' ? 'items-end' : 'items-start');

/**
 * Get the main bubble/message box styles
 * Includes background, padding, borders, and role-specific styling
 */
export const getBubbleStyles = (role: 'user' | 'assistant') =>
  cn(
    'relative w-fit mb-0.5 text-sm tracking-normal',
    role === 'user'
      ? 'bg-primary text-primary-foreground rounded-xl rounded-tr-md ml-auto px-4 py-2'
      : 'px-2 py-0',
  );

/**
 * Get the action button container styles
 * Shows on hover with smooth transition
 */
export const getActionButtonContainerStyles = (role: 'user' | 'assistant') =>
  cn(
    'flex items-center gap-1 mt-0.5 mb-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200',
    role === 'user' ? 'mr-2' : 'ml-2',
  );

/**
 * Get individual action button styles
 */
export const getActionButtonStyles = () =>
  cn('p-1 rounded hover:bg-muted transition-colors');

/**
 * Animation classes for fade-in effect (no animation when clearing)
 */
export const getFadeInAnimationClass = () => cn();

/**
 * Animation styles (no animation when clearing chat)
 */
export const getFadeOutAnimationStyle = (): {
  transitionDuration: string;
  transitionDelay: string;
} => ({
  transitionDuration: '0ms',
  transitionDelay: '0ms',
});
